import { createSelector } from 'reselect';

import { selectPropertyGeolocation } from 'flux/selectors/property.selectors';
import { selectCurrentStoreGeolocation } from 'flux/selectors/stores.selectors';
import { selectRouterGeolocation } from 'flux/selectors/router.selectors';
import { selectUserGeolocation } from 'flux/selectors/user.selectors';
import { selectDefaultGeolocation } from 'flux/selectors/application.selectors';

export const selectTrackingGeolocation = (state) =>
  createSelector(
    [
      selectCurrentStoreGeolocation,
      selectRouterGeolocation,
      selectUserGeolocation,
      selectPropertyGeolocation,
      selectDefaultGeolocation,
    ],
    (
      currentStoreGeolocation,
      routerGeolocation,
      userGeolocation,
      propertyGeolocation,
      defaultGeolocation,
    ) =>
      currentStoreGeolocation ||
      routerGeolocation ||
      userGeolocation ||
      propertyGeolocation ||
      defaultGeolocation,
  )(state);

export const selectTrackingViewerPercentages = (state) => state.tracking.viewerPercentages;

export const selectFlyerOpenSent = (state) => state.tracking.flyerOpenSent;

export const hasBeenFlyerOpenSent = (state, id) => state.tracking.flyerOpenSent.includes(id);

export const selectSessionFlyerId = (state) => state.tracking.sessionFlyerId;
